import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import Loader from "../components/animated/Loader";
import TransitionalHeader from "../components/TransitionalHeader";
import GenerosManifestoContent from "../components/GenerosManifestoContent";
import WhatIf from "../partials/WhatIf";
import TransitionalFooter from "../components/TransitionalFooter";
import Button from "../components/Button";
import { useSearchQuery } from "../hooks";
import { joinWaitList } from "../utils/helpers";

function TransitionalHome() {
  const history = useHistory();
  const searchQuery = useSearchQuery();
  const inviterUsername = searchQuery.get("inviterUsername");

  useEffect(() => {
    if (inviterUsername) {
      localStorage.setItem("genInviteUsername", inviterUsername);
    }
  }, [inviterUsername]);

  const goToJoinWaitlist = () => joinWaitList(history);

  return (
    <div className="flex flex-col min-h-screen overflow-hidden">
      <TransitionalHeader />
      <main className="grow">
        <HeroSection />
        <WhatIf onJoinGenerosClick={goToJoinWaitlist} />
        <GenerosManifestoContent showTopBorder />
        <LeadCaptureSection onJoinGenerosClick={goToJoinWaitlist} />
        <div className="mt-10" data-aos="fade-up" data-aos-delay="200">
          <Button
            variant="primary-w"
            textSize="text-xl"
            onClick={goToJoinWaitlist}
          >
            Join Generos
          </Button>
        </div>
      </main>
      <TransitionalFooter />
    </div>
  );
}

function HeroSection() {
  return (
    <section className="relative pt-32 pb-12 md:pt-40 md:pb-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
        <h1
          className="text-white text-4xl md:text-6xl lg:text-7xl font-extrabold font-barlow tracking-tight leading-tight"
          data-aos="fade-up"
        >
          AI is automating labor.
          <br />
          <span className="text-primary-1">
            You were made for something machines can&rsquo;t replace.
          </span>
        </h1>
        <p
          className="mt-10 text-lilac-400 text-xl md:text-2xl font-semibold max-w-2xl mx-auto leading-relaxed"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          Turn virtue into a system that benefits humanity and you.
        </p>
      </div>
    </section>
  );
}

function LeadCaptureSection({ onJoinGenerosClick }) {
  return (
    <section className="py-16 md:py-24">
      <div className="max-w-xl mx-auto px-4 sm:px-6 text-center">
        <div
          className="flex justify-center items-center h-16 mb-10 w-full"
          data-aos="fade-up"
          aria-hidden="true"
        >
          <Loader className="w-1/2" isPrimaryColor={true} />
        </div>
      </div>
    </section>
  );
}

export default TransitionalHome;
